import { render, staticRenderFns } from "./AppScrollToTop.vue?vue&type=template&id=56cf4818&"
import script from "./AppScrollToTop.vue?vue&type=script&lang=js&"
export * from "./AppScrollToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports